import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';

import {
  bodyTypesState,
  hasSelectedBodyTypesSelector,
  resetSelectedBodyTypesSelector,
  selectBodyType,
  selectedBodyTypesSelector,
  toggleBodyType,
} from '@/states/filters/body-type.state';

export function useBodyTypesFilter() {
  const [bodyTypesFilter, setBodyTypesFilter] = useRecoilState(bodyTypesState);

  const bodyTypesSelectedFilters = useRecoilValue(selectedBodyTypesSelector);
  const visibleBodyTypes = useRecoilValue(bodyTypesState);

  const toggleBodyTypeFilter = useSetRecoilState(toggleBodyType);
  const selectBodyTypeFilter = useSetRecoilState(selectBodyType);

  const resetSelectedBodyTypes = useSetRecoilState(
    resetSelectedBodyTypesSelector
  );
  const hasSelectedBodyTypes = useRecoilValue(hasSelectedBodyTypesSelector);

  return {
    bodyTypesFilter,
    setBodyTypesFilter,
    bodyTypesSelectedFilters,
    toggleBodyTypeFilter,
    resetSelectedBodyTypes,
    hasSelectedBodyTypes,
    selectBodyTypeFilter,
    visibleBodyTypes,
  };
}
